export default () => ({
  status: undefined,
  newCameraDialog: undefined,
  items: [],
});
